import { render, staticRenderFns } from "./NewTabs3.vue?vue&type=template&id=2b447ccb&scoped=true"
import script from "./NewTabs3.vue?vue&type=script&lang=js"
export * from "./NewTabs3.vue?vue&type=script&lang=js"
import style0 from "./NewTabs3.vue?vue&type=style&index=0&id=2b447ccb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b447ccb",
  null
  
)

export default component.exports